/**
 * Intercetta la voce di menu "Gestisci preferenze cookie"
 * e apre il pannello preferenze del banner Shopify.
 */
(function () {
  const LABELS = [
    'gestisci preferenze cookie',
    'preferenze cookie',
    'cookie preferences',
    'manage cookie preferences',
  ];

  function normalize(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isCookiePreferencesAnchor(anchor) {
    if (!(anchor instanceof HTMLAnchorElement)) return false;

    const label = normalize(anchor.textContent);
    if (LABELS.some((item) => label === item || label.includes(item))) {
      return true;
    }

    const href = normalize(anchor.getAttribute('href'));
    return (
      href.includes('gestisci-preferenze-cookie') ||
      href.includes('cookie-preferences') ||
      href === '#cookie' ||
      href === '#cookies' ||
      href === '#preferenze-cookie'
    );
  }

  function openCookiePreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    window.location.href = '/?preview_privacy_banner=1';
  }

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target.closest('a');
      if (!anchor || !isCookiePreferencesAnchor(anchor)) return;

      event.preventDefault();
      event.stopPropagation();
      openCookiePreferences();
    },
    true
  );
})();
